import { Alert, Snackbar } from "@mui/material";
import styled from "styled-components";
import theme from "../theme";
import { useI18n } from "../locales";

interface ToastMsgType {
  open: boolean;
  handleClose?: (
    event: React.SyntheticEvent | Event,
    reason?: string
  ) => void;
  accidentDate: string;
}

const RedToastMsg: React.FC<ToastMsgType> = (props) => {
  const { open, handleClose } = props;
  const { t } = useI18n();

  return (
    <Snackbar
      sx={{
        position: "fixed",
        zIndex: 1001, // 모달(98) 및 모달 내부 요소(1000)보다 위에 표시
        // theme.screen.sm보다 작을 때
        [`@media (max-width: ${theme.screen.sm}px)`]: {
          width: "100vw",
          bottom: "125px",
          left: "50%",
          transform: "translateX(-50%)",
        },
        // theme.screen.sm과 theme.screen.md 사이일 때
        [`@media (min-width: ${theme.screen.sm + 1}px) and (max-width: ${theme.screen.md}px)`]: {
          width: "100vw",
          bottom: "125px",
          left: "50%",
          transform: "translateX(-50%)",
        },
        // theme.screen.md보다 클 때
        [`@media (min-width: ${theme.screen.md + 1}px)`]: {
          width: "auto",
          maxWidth: "90%",
          marginBottom: "30px",
          bottom: "50px",
          transform: "translateX(-50%)",
          left: "50%",
        },
        // MUI Snackbar의 기본 스타일 제거 (사용자 정의 스타일이 우선 적용되도록)
        "&.MuiSnackbar-root": {
          right: "auto !important",
          zIndex: `1001 !important`, // 모달(98) 및 모달 내부 요소(1000)보다 위에 표시
          // MUI의 600px 이상 기본 스타일 제거
          "@media (min-width: 600px)": {
            right: "auto !important",
            left: "50% !important",
            transform: "translateX(-50%) !important",
            zIndex: `1001 !important`, // 모달(98) 및 모달 내부 요소(1000)보다 위에 표시
          },
        },
      }}
      anchorOrigin={undefined}
      ContentProps={{
        sx: {
          textAlign: "center",
        },
      }}
      open={open}
      onClose={handleClose}
    >
      <Alert
          severity="error"
          sx={{
            backgroundColor: theme.color.pastelRed_500,
            textAlign: "center",
            width: "100%",
            maxWidth: "100%",
            // PC 화면에서는 적절한 너비로 가운데 정렬
            [`@media (min-width: ${theme.screen.md + 1}px)`]: {
              margin: "0 auto",
              width: "auto",
              maxWidth: "100%",
            },
            // 모바일에서 좌우 여백 최소화하여 넓게 표시
            [`@media (max-width: ${theme.screen.md}px)`]: {
              margin: "0 5px",
              width: "calc(100% - 10px)",
              minWidth: "calc(100vw - 10px)",
            },
            "& .MuiAlert-message": {
              textAlign: "center",
              width: "inherit",
              color: theme.color.white,
              fontWeight: 700,
              paddingLeft: "10px",
              paddingRight: "20px",
            },
            "& .MuiSvgIcon-root": {
              fill: theme.color.white,
            },
          }}
        >
        {t.control.rolloverAccidentDetected}{" "}
        <BrContainer>
          <br />
        </BrContainer>
        {t.control.checkUserSafetyImmediately}
        {/* <strong
            style={{
              display: "block",
              marginTop: "10px",
              position: "relative",
              // left: "-12px",
            }}
          >
            {timeDisplay}
          </strong> */}
      </Alert>
    </Snackbar>
  );
};

const BrContainer = styled.p`
  display: none;
  height: 0;
  @media (max-width: ${theme.screen.sm}px) {
    display: block;
  }
`;

export default RedToastMsg;
